import { Field, Float, ID, InputType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import type { ReturnOrder } from '../ReturnOrder'

/**
 * One slice of the actual refund directed at a single refundable source order payment.
 * Allocation amounts across a confirm must sum to the return's refund total (gross).
 */
@InputType()
export class RefundAllocationInput {
  @Field(() => ID)
  paymentId: string

  @Field(() => Float)
  amount: number
}

@InputType()
export class ConfirmReturnOrderArgs extends ActionArgs {
  @Field(() => ID)
  returnOrderId: string

  /**
   * Required when the source order has more than one refundable payment (the chooser's split);
   * with exactly one refundable payment the backend auto-allocates and this may be omitted.
   */
  @Field(() => [RefundAllocationInput], { nullable: true })
  refundAllocations?: RefundAllocationInput[]
}

export interface IConfirmReturnOrder extends IAction<ReturnOrder, ConfirmReturnOrderArgs> {}
